export default __webpack_public_path__ + "static/bell_b.57ad3f7eb20d53196c52eafb20b6897c.png";